/* Product photo zoom (Craft product-media-modal).
   AMOR 8.10.2026: Craft showed the tapped photo on a phone at 1100px wide inside a 375px window, so a
   customer saw only a fragment of the furniture (Clarity recording: swiped around, then left). Now
   amor-lightbox.css lays the photos side by side on phones, each the width of the screen; this script
   scrolls straight to the tapped photo and keeps a "2 / 5" counter. Larger screens keep Craft's
   column of photos (each fitted to the window height in amor-lightbox.css). */
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        const items = Array.from(container.children);
        if (window.matchMedia('(max-width: 749px)').matches) {
          const slot = activeMedia.closest('.product-media-modal__content > *') || activeMedia;
          container.scrollLeft = Math.max(0, items.indexOf(slot)) * container.clientWidth;
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }
        this.updateCount(container, items);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      /* Counter for phones: which photo of how many. Visual only (each photo has its own alt text). */
      updateCount(container, items) {
        if (items.length < 2) return;
        if (!this.countEl) {
          this.countEl = document.createElement('p');
          this.countEl.className = 'am-lb-count';
          this.countEl.setAttribute('aria-hidden', 'true');
          this.querySelector('[role="dialog"]').appendChild(this.countEl);
          let frame = 0;
          container.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(frame);
              frame = requestAnimationFrame(() => this.updateCount(container, items));
            },
            { passive: true }
          );
        }
        const i = Math.round(container.scrollLeft / Math.max(1, container.clientWidth));
        this.countEl.textContent = `${Math.min(items.length, i + 1)} / ${items.length}`;
      }
    }
  );
}

/* Photos in the product description open in this same zoom, at that photo (9.10.2026).
   Clarity: customers tapped the description photos (sections/am-product-description) and nothing happened.
   Each of them is one of the product's own photos, so it is matched to a photo in the zoom by file name.
   A picture that is not in the zoom (another product's photo, a picture inside a link) is left as it is.
   The button covers the whole photo; the round "+" mark is the same as on the gallery photos. */
(() => {
  const main = document.querySelector('[id^="MainProduct-"]');
  const modal = main
    ? document.getElementById('ProductModal-' + main.id.replace('MainProduct-', ''))
    : document.querySelector('product-modal');
  if (!modal) return;
  const file = (src) => String(src || '').split('?')[0].split('/').pop();
  const ids = {};
  modal.querySelectorAll('img[data-media-id]').forEach((img) => {
    ids[file(img.getAttribute('src'))] = img.getAttribute('data-media-id');
  });
  const ICON =
    '<span class="pd-zoom__ic" aria-hidden="true"><svg viewBox="0 0 19 19" fill="none">' +
    '<path fill="currentColor" fill-rule="evenodd" d="M4.667 7.94a.5.5 0 0 1 .499-.501l5.534-.014a.5.5 0 1 1 .002 1l-5.534.014a.5.5 0 0 1-.5-.5" clip-rule="evenodd"/>' +
    '<path fill="currentColor" fill-rule="evenodd" d="M7.926 4.665a.5.5 0 0 1 .501.498l.014 5.534a.5.5 0 1 1-1 .003l-.014-5.534a.5.5 0 0 1 .499-.501" clip-rule="evenodd"/>' +
    '<path fill="currentColor" fill-rule="evenodd" d="M12.832 3.03a6.931 6.931 0 1 0-9.802 9.802 6.931 6.931 0 0 0 9.802-9.802M2.323 2.323a7.931 7.931 0 0 1 11.296 11.136l4.628 4.628a.5.5 0 0 1-.707.707l-4.662-4.662A7.932 7.932 0 0 1 2.323 2.323" clip-rule="evenodd"/>' +
    '</svg></span>';
  document.querySelectorAll('.am-pdp-desc figure img').forEach((img) => {
    const fig = img.closest('figure');
    const id = ids[file(img.getAttribute('src'))];
    if (!id || img.closest('a, button') || fig.querySelector(':scope > .pd-zoom')) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pd-zoom';
    btn.setAttribute('data-media-id', id);
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.setAttribute('aria-label', (window.AMOR_I18N || {}).pm_zoom || 'Powiększ zdjęcie');
    btn.innerHTML = ICON;
    btn.addEventListener('click', () => modal.show(btn));
    fig.classList.add('pd-zoomable');
    fig.appendChild(btn);
  });
})();

/* Phones: a tap on a photo in the zoom shows it closer, a tap beside the photo closes the zoom (12.10.2026).
   Clarity (30 days): in four sessions customers tapped a photo or the empty space in the zoom and nothing happened
   (Craft closes the zoom on a mouse click only). The closer view is a separate layer over the zoom: the same photo,
   in its largest size, 2.5 times the screen width, scrolled so the tapped spot is in the middle; one finger moves it,
   a tap closes it and returns to the swipe gallery. Larger screens keep Craft's behaviour. */
(() => {
  const phone = window.matchMedia('(max-width: 749px)');
  const largest = (img) => {
    let best = img.currentSrc || img.src;
    let bestW = 0;
    String(img.getAttribute('srcset') || '').split(',').forEach((part) => {
      const [u, d] = part.trim().split(/\s+/);
      const w = parseInt(d, 10) || 0;
      if (u && w > bestW) { bestW = w; best = u; }
    });
    return best;
  };
  const closeZoom = (layer) => {
    if (!layer || !layer.isConnected) return;
    const back = layer.amFrom;
    layer.remove();
    if (back && back.focus) back.focus({ preventScroll: true });
  };
  document.addEventListener('click', (e) => {
    if (!phone.matches || !e.target.closest) return;
    const content = e.target.closest('product-modal .product-media-modal__content');
    if (!content) return;
    const modal = content.closest('product-modal');
    const img = e.target.closest('img');
    if (!img || !content.contains(img)) {
      if (e.target === content) modal.hide();
      return;
    }
    const r = img.getBoundingClientRect();
    if (!r.width || !r.height) return;
    const fx = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
    const fy = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
    const ratio = img.naturalWidth && img.naturalHeight ? img.naturalHeight / img.naturalWidth : r.height / r.width;
    const w = Math.round(window.innerWidth * 2.5);
    const layer = document.createElement('div');
    layer.className = 'am-lb-zoom';
    layer.tabIndex = 0;
    layer.setAttribute('role', 'button');
    layer.setAttribute('aria-label', (window.AMOR_I18N || {}).pm_zoom_close || 'Zamknij przybliżenie');
    layer.amFrom = img;
    const big = document.createElement('img');
    big.alt = img.alt || '';
    big.decoding = 'async';
    big.style.width = w + 'px';
    big.style.height = Math.round(w * ratio) + 'px';
    big.src = img.currentSrc || img.src;
    const hint = document.createElement('p');
    hint.className = 'am-lb-zoom__hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.textContent = (window.AMOR_I18N || {}).pm_tap_back || 'Dotknij, aby wrócić';
    layer.append(big, hint);
    (modal.querySelector('[role="dialog"]') || modal).appendChild(layer);
    layer.scrollLeft = fx * w - layer.clientWidth / 2;
    layer.scrollTop = fy * w * ratio - layer.clientHeight / 2;
    const hi = largest(img);
    if (hi && hi !== big.src) {
      const pre = new Image();
      pre.onload = () => { if (layer.isConnected) big.src = hi; };
      pre.src = hi;
    }
    layer.addEventListener('click', () => closeZoom(layer));
    layer.addEventListener('keydown', (k) => {
      if (k.key === 'Enter' || k.key === ' ' || k.key === 'Escape') { k.preventDefault(); k.stopPropagation(); closeZoom(layer); }
    });
    layer.focus({ preventScroll: true });
    if (window.amClarity && window.amClarity.event) window.amClarity.event('galeria_przyblizenie');
  });
  /* The zoom itself closing (X button, Escape) takes the closer view with it. */
  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('.product-media-modal__toggle')) document.querySelectorAll('.am-lb-zoom').forEach((l) => l.remove());
  }, true);
})();
